import React from 'react';
import {
  DemographicsCardWrapper,
  DemographicsCardText,
  DemographicsCardIconWrapper,
  DemographicsCardAlignWrapper,
} from './styled';
import EducationIcon from 'assets/svg/demographics/education.svg';
import FamilyIcon from 'assets/svg/demographics/family.svg';
import IncomeIcon from 'assets/svg/demographics/income.svg';
import OccupationIcon from 'assets/svg/demographics/occupation.svg';
import AgeGroupIcon from 'assets/svg/demographics/agegroup.svg';
import { DemographicsCategory } from 'store/state/selectors/insights/summaryTypes';

export interface DemographicsCardProps {
  text: string;
  category: DemographicsCategory;
}

const mapDemographicsCategoryToIcon: Record<DemographicsCategory, React.ReactNode> = {
  [DemographicsCategory.AgeGroup]: <AgeGroupIcon/>,
  [DemographicsCategory.Family]: <FamilyIcon/>,
  [DemographicsCategory.Income]: <IncomeIcon/>,
  [DemographicsCategory.Education]: <EducationIcon/>,
  [DemographicsCategory.Occupation]: <OccupationIcon/>,
};

export const DemographicsCard: React.FC<DemographicsCardProps> = React.memo(({ text, category }) => {
  return (
    <DemographicsCardWrapper>
      <div>
        <DemographicsCardAlignWrapper>
          <DemographicsCardIconWrapper>
            {mapDemographicsCategoryToIcon[category]}
          </DemographicsCardIconWrapper>
          <DemographicsCardText>
            {text}
          </DemographicsCardText>
        </DemographicsCardAlignWrapper>
      </div>
    </DemographicsCardWrapper>
  );
});
